module.exports = __webpack_public_path__ + "static/media/telstraWhiteOnly.22fb4a34.svg";